<script>
import { isNil } from 'lodash/fp'

export default {
  name: 'FilterCheckbox',
  props: {
    filter: {
      type: Object,
      required: true
    },
    filterIndex: Number,
    value: [Object, Boolean]
  },
  data () {
    return {
      expanded: true,
      loading: false
    }
  },
  computed: {
  },
  methods: {
    iconClicked (e) {
      console.log('event: ', event)
      e.stopPropagation()
      e.preventDefault()

      const currentValue = this.value
      console.log('currentValue', currentValue)

      let emitValue
      if (currentValue) {
        emitValue = false
      } else if (isNil(currentValue)) {
        emitValue = true
      } else {
        emitValue = null
      }

      // If the currentvalue is chosen, emit 'null' instead to 'deselect' it
      this.$emit('update', emitValue)
    }
  },
  render (h) {
    let icon = 'mdi-checkbox-blank-outline'
    let iconColor
    switch (this.value) {
      case true:
        icon = 'mdi-checkbox-marked'
        iconColor = 'success'
        break

      case false:
        icon = 'mdi-close-box'
        iconColor = 'error'
        break

      case null:
      default:
        icon = 'mdi-checkbox-blank-outline'
        iconColor = undefined
    }

    return (
      <div class="filter-boolean" onClick={this.iconClicked} v-ripple>
        <span class=" ml-1 mr-2">{this.filter.label}</span>

        <v-icon
          color={iconColor}
        >{icon}</v-icon>
      </div>
    )
  }
}
</script>

<style lang="stylus" scoped>
// @import '~vuetify/src/stylus/settings/_colors.styl'

.filter-boolean
  display: flex
  align-items: center
  justify-content: space-between
  user-select: none
  cursor: pointer
  padding:8px 12px

  &:hover
    background-color: rgba(88, 88, 88, .2)

</style>
